export function getPersistData(key) {
	try {
		const cache = localStorage.getItem('app-cache')
		if (cache) {
			const map = new Map(JSON.parse(cache))
			const data: any = map.get(key)
			if (data) {
				return data.data
			}
			return null
		} else {
			return null
		}
	} catch (e) {
		// 시크릿 모드 등에서 localStorage 접근 실패 시 null 반환
		console.warn('localStorage access failed (possibly in incognito mode):', e)
		return null
	}
}
